import { render, staticRenderFns } from "./courseDetail.vue?vue&type=template&id=1bfeae5b&scoped=true&"
import script from "./courseDetail.vue?vue&type=script&lang=js&"
export * from "./courseDetail.vue?vue&type=script&lang=js&"
import style0 from "./courseDetail.vue?vue&type=style&index=0&id=1bfeae5b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfeae5b",
  null
  
)

export default component.exports